import React, { useEffect, useRef } from 'react';
var SnippylyCursor = function (props) {
    var allowedElementIds = props.allowedElementIds, avatarMode = props.avatarMode, inactivityTime = props.inactivityTime, onCursorUsersChanged = props.onCursorUsersChanged, onCursorUserChange = props.onCursorUserChange, children = props.children;
    var ref = useRef();
    var onCursorUsersChangedRef = useRef(onCursorUsersChanged);
    var onCursorUserChangeRef = useRef(onCursorUserChange);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onCursorUsersChangedRef.current = onCursorUsersChanged;
    }, [onCursorUsersChanged]);
    useEffect(function () {
        onCursorUserChangeRef.current = onCursorUserChange;
    }, [onCursorUserChange]);
    useEffect(function () {
        var element;
        var handleCursorUserChange = function (event) {
            if (onCursorUsersChangedRef.current) {
                onCursorUsersChangedRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
            if (onCursorUserChangeRef.current) {
                onCursorUserChangeRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onCursorUserChange', handleCursorUserChange);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onCursorUserChange', handleCursorUserChange);
            }
        };
    }, []);
    return (React.createElement("velt-cursor", { ref: ref, "allowed-element-ids": allowedElementIds, "avatar-mode": avatarMode ? 'true' : undefined, "inactivity-time": inactivityTime }, children));
};
export default SnippylyCursor;
